import camelCase from 'lodash/camelCase';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { versionDetailsRelayResourceCustom } from '@jira/router-resources__software-versions/src/versionDetailsRelayResourceCustom.tsx';
import { softwareVersionDetailEmbedRoute } from '@jira/router-routes__software-versions-routes/src/softwareVersionDetailEmbedRoute.tsx';
import { VersionDetailSkeleton } from '@jira/platform__skeletons/src/ui/versions/VersionDetailSkeleton.tsx';
import { LazyVersionDetail, VersionDetailPage } from './ui/version-detail/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

// RouteEntry for the Embed view for Version Details. This is only used for Smartlinks in Confluence.
export const softwareVersionDetailEmbedRouteEntry: Route = createEntry(
	softwareVersionDetailEmbedRoute,
	() => ({
		group: 'software',
		ufoName: 'software.version-details-page-embed',
		// eslint-disable-next-line no-restricted-syntax
		component: VersionDetailPage,
		skeleton: VersionDetailSkeleton,
		canTransitionIn: () => true,

		layout: createLayout({
			isChromeless: true,
		}),

		resources: [
			...getNavigationResources(),
			versionDetailsRelayResourceCustom,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
		],

		forPaint: [LazyVersionDetail],

		meta: {
			reporting: {
				id: 'software-version-detail-embed',
				packageName: camelCase('software-version-detail-embed'),
				teamName: 'a4t-pandora',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
